import React from "react";
import { useQuery } from "../../_utils/url_query_hook";
import { buildEmptyCompetencyGroup, transformEntityCompetencyGroup } from "../../_events/competency-group/model";
import { findCompetencyGroupByIdEvent } from "../../_events/competency-group/find.event";
import { createCompetencyGroupEvent, editCompetencyGroupEvent } from "../../_events/competency-group/create.event";
import { alertError, alertSuccess } from "../../_utils/alerts";

export const useCompetencyGroupCreateEdit = () => {

    const query = useQuery();
    const uuid = query.get("id");

    const [ entity, setEntity ] = React.useState(buildEmptyCompetencyGroup());

    const create = () => {
        createCompetencyGroupEvent(entity)
        .then(json => {
            alertSuccess("Guardado");
            setEntity(buildEmptyCompetencyGroup());
        })
        .catch(err => {
            alertError(err.message);
        });
    }

    const edit = () => {
        editCompetencyGroupEvent(uuid, entity)
        .then(json => {
            alertSuccess("Actualizado");
        })
        .catch(err => {
            alertError(err.message);
        });
    }

    React.useEffect(() => {
        if(uuid){
            findCompetencyGroupByIdEvent(uuid)
            .then(json => {
                setEntity(transformEntityCompetencyGroup(json.data));
            })
            .catch(err => {
                alertError(err.message);
            })
        }
    }, [uuid]);

    return { entity, setEntity, uuid, create, edit };
}